import { render } from "./WatchedMovie.vue?vue&type=template&id=15d787db"
import script from "./WatchedMovie.vue?vue&type=script&lang=js"
export * from "./WatchedMovie.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rezaradfar/Sites/vue-udemy-projects/vue-movie-rating/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__